import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { messageType } from '../../types';
import DateTime, { LONG_DATETIME } from '../DateTime';
import './_styles_/MessageRow.css';
import transformMessage from './messageTransformer';

const SEVERITY_ICONS = {
    ERROR: 'exclamation-triangle',
    WARN: 'exclamation-circle',
    INFO: 'info-circle',
};

MessageRow.propTypes = {
    message: messageType.isRequired,
};

function MessageRow(props) {
    const {
        message,
    } = props;
    const { t, i18n } = useTranslation();
    const { severity } = message;
    return (
        <div className="rich-list-row message-header">
            <div className="message-header--values--last-update-time readonly"><DateTime value={message.lastUpdateTime} format={LONG_DATETIME} /></div>
            <div className="message-header--values--severity readonly">
                {severity && (
                    <span
                        className={`message-severity message-severity--${severity.toLowerCase()}`}
                        title={t(`messages.severity.${severity}`)}
                        aria-label={t(`messages.severity.${severity}`)}
                    >
                        <FontAwesomeIcon icon={SEVERITY_ICONS[severity] || SEVERITY_ICONS.INFO} />
                    </span>
                )}
            </div>
            <div className="message-header--values--message readonly">{transformMessage(i18n, message.messageKey, message.params)}</div>
        </div>
    );
}

export default MessageRow;
